import { Typography } from 'antd';
import styles from './PageDescription.module.css';

export const PageDescription = ({ title }) => {
  const { Title } = Typography;

  return (
    <div className={styles.descriptionBox}>
      <Title level={2} style={{ marginBottom: 0 }}>
        {title}
      </Title>
      {/* <Text type='secondary'>{description}</Text> */}
    </div>
  );
};
